import React, { useState } from 'react';
import { useHistory } from 'react-router';

import { useDispatch, useSelector } from 'react-redux';
import * as PanelNames from '../../redux/panel/PanelNames';
import {
    readAllNotificationsAsync,
    readNotificationAsync,
    unreadNotificationAsync
} from '../../redux/notification/Actions';
import { fetchSearchAsync } from '../../redux/search/Actions';
import { showSecondaryPanel } from '../../redux/panel/Actions';
import { fetchAnalysisAsync } from '../../redux/analysis/Actions';
import { setCurrentPlanningReportAsync } from '../../redux/planning/Actions';
import { setCurrentProjectAsync } from '../../redux/project/Actions';

import {
    Button,
    Popper,
    Grow,
    Typography,
    ClickAwayListener,
    Badge,
    Box,
    makeStyles
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';

import Notification from './Notification';
import ScrollableContainer from '../utility/ScrollableContainer';

const useStyles = makeStyles(theme => styles(theme));

function Notifications() {
    const classes = useStyles();
    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [viewAll, setViewAll] = useState(false);

    const currentProject = useSelector(state => state.project.currentProject);
    const notifications = useSelector(state => state.notificationReducer.notifications);

    const dispatch = useDispatch();
    function dispatchReadNotification(id) {
        dispatch(readNotificationAsync(id));
    }
    function dispatchUnreadNotification(id) {
        dispatch(unreadNotificationAsync(id));
    }
    function dispatchReadAllNotifications() {
        dispatch(readAllNotificationsAsync());
    }

    function dispatchShowSecondaryPanel(panel) {
        dispatch(showSecondaryPanel(panel));
    }
    // Below are specific actions to load notifications
    function dispatchFetchSearch(id) {
        dispatch(fetchSearchAsync(id));
    }
    function dispatchFetchAnalysis(id) {
        dispatch(fetchAnalysisAsync(id));
    }
    function dispatchSetCurrentPlanningReportAsync(id) {
        dispatch(setCurrentPlanningReportAsync(id));
    }
    function dispatchSetCurrentProject(id) {
        if (currentProject.id !== id) dispatch(setCurrentProjectAsync(id));
    }

    // const authenticity_token = document.querySelector('meta[name=\'csrf-token\']').getAttribute('content');

    function handlePopperOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handlePopperClose() {
        setAnchorEl(null);
    }

    function handleNotificationClick(notification) {
        // history.push(notification.url);
        handlePopperClose();
        switch (notification.notificationType) {
            case 'search':
                history.push('/map');
                // Dirty method to force the project to change, potential race conditions, should load different project then analysis or both at once
                dispatchSetCurrentProject(notification.properties.projectId);
                // Search panel should show something custom to indicate it is loading a search
                dispatchFetchSearch(notification.notificationId);
                dispatchShowSecondaryPanel(PanelNames.SEARCH);
                break;
            case 'analysis':
                history.push('/map');
                // Dirty method to force the project to change, potential race conditions, should load different project then analysis or both at once
                dispatchSetCurrentProject(notification.properties.projectId);
                //
                dispatchFetchAnalysis(notification.notificationId);
                dispatchShowSecondaryPanel(PanelNames.SEARCH);
                break;
            case 'planning_report':
                history.push('/map');
                // Dirty method to force the project to change, potential race conditions, should load different project then analysis or both at once
                dispatchSetCurrentProject(notification.properties.projectId);
                //
                dispatchSetCurrentPlanningReportAsync(notification.notificationId);
                dispatchShowSecondaryPanel(PanelNames.PLANNING_ALERTS);
                break;
            case 'fulfill_order':
                history.push({
                    pathname: notification.notificationId
                        ? `/dashboard/sites/${notification.notificationId.siteCardId}`
                        : '/dashboard/documents',
                    state: notification.notificationId?.siteCardId
                });
                // ToDo really should have url on order that redirects to the appropriate location
                break;
            case 'paid_order':
                history.push(`/dashboard/sites/orders/${notification.notificationId}`);
                // ToDo really should have url on order that redirects to the appropriate location
                break;
            default:
                console.error('unidentified notification');
        }
    }

    // Replace with a page change
    function handleViewAll() {
        setViewAll(!viewAll);
    }

    const recentNotifications = viewAll ? notifications : notifications.slice(0, 5);
    // TODO, shouldn't load down all notifications, so should have cached value for number of cached notifications for a user, see rails cache_counter
    const numUnread = notifications.reduce((acc, cur) => (cur.read ? acc : acc + 1), 0);

    return (
        <>
            <div>
                <Button className={classes.button} variant="outlined" onClick={handlePopperOpen}>
                    <Badge
                        classes={{
                            badge: classes.badge
                        }}
                        color="error"
                        overlap="circular"
                        variant="dot"
                        invisible={numUnread === 0}
                        // badgeContent={""}
                        // max={99}
                    >
                        <NotificationsIcon />
                    </Badge>
                </Button>
            </div>
            <Popper
                className={classes.popper}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                placement="bottom-end"
                transition
                disablePortal={false}
                popperOptions={{
                    modifiers: {
                        offset: {
                            offset: '0,38' // 4 extra padding in header + 14 header bottom margin + 20 map top padding
                        }
                    }
                }}>
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                        <div>
                            <ClickAwayListener onClickAway={handlePopperClose}>
                                <Box className={classes.panel} boxShadow={2}>
                                    <div className={classes.header}>
                                        <Typography variant="h4">Notifications</Typography>
                                        <Button
                                            className={classes.markAllAsReadButtom}
                                            variant="text"
                                            onClick={dispatchReadAllNotifications}>
                                            Mark all as read
                                        </Button>
                                    </div>
                                    <ScrollableContainer className={classes.menu}>
                                        {recentNotifications.map(el => (
                                            <Notification
                                                key={el.id}
                                                notification={el}
                                                onNotificationClick={handleNotificationClick}
                                                onNotificationRead={dispatchReadNotification}
                                                onNotificationUnread={dispatchUnreadNotification}
                                            />
                                        ))}
                                    </ScrollableContainer>
                                    <div className={classes.moreButton}>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            color="secondary"
                                            onClick={handleViewAll}
                                            disabled={notifications.length <= 5}>
                                            {viewAll ? 'SHOW LESS' : 'VIEW ALL'}
                                        </Button>
                                    </div>
                                </Box>
                            </ClickAwayListener>
                        </div>
                    </Grow>
                )}
            </Popper>
        </>
    );
}

const styles = theme => ({
    root: {
        height: '100%',
        display: 'flex',
        position: 'relative',
        boxSizing: 'border-box'
    },
    button: {
        padding: 5,
        minWidth: 0
    },
    badge: {
        top: '20%',
        right: '20%',
        border: `1px solid ${theme.palette.primary.main}`
    },
    popper: {
        zIndex: theme.zIndex.popover,
        width: 300
    },
    panel: {
        backgroundColor: theme.palette.background.main,
        borderRadius: theme.constants.radius.sm,
        overflow: 'hidden'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.background.dark,
        color: theme.palette.text.primary,
        padding: theme.constants.spacing.md
    },
    markAllAsReadButtom: {
        ...theme.typography.caption,
        color: theme.palette.primary.light,
        lineHeight: 1,
        textTransform: 'initial'
    },
    menu: {
        maxHeight: 500,
        '& > *:not(:last-child)': {
            borderBottom: `1px solid ${theme.palette.background.border}`
        }
    },
    moreButton: {
        borderTop: `1px solid ${theme.palette.background.border}`,
        padding: `${theme.constants.spacing.md}px`
    }
});

export default Notifications;
